// Use Timestamp to avoid impact of clock adjustments that may happen during
// a measurement. We use `performance.now` if available not for the higher
// precision, but for the monotonically increasing guarantee.

// However `performance.now`'s time origin is dependent on the browsing context.
// To compare a timestamp across frame boundary, it must be converted into POSIX
// time value

export const dateNow = Date.now ? () => Date.now() : () => new Date().getTime();

const timeOrigin = dateNow();

const getTimestamp =
  window.performance && window.performance.now
    ? () => window.performance.now()
    : () => dateNow() - timeOrigin;

export class Timestamp {
  timestampValue: number;

  constructor(value?: number) {
    this.timestampValue = value != null ? value : getTimestamp();
  }

  static fromPosixTime(posixTime: number): Timestamp {
    const nowPosix = dateNow();
    const nowTimestamp = getTimestamp();

    return new Timestamp(posixTime - nowPosix + nowTimestamp);
  }

  getAsPosixTime(): number {
    return dateNow() - this.getElapsedTime();
  }

  getElapsedTime(until?: Timestamp): number {
    // Round to nearest millisecond as consumers do not expect higher precision
    return Math.round(
      (until ? until.timestampValue : getTimestamp()) - this.timestampValue,
    );
  }

  valueOf() {
    return Math.round(this.timestampValue);
  }
}
